<template>
  <div class="inner-container">
    <!-- custom, didnt like veutify -->
    <div class="inner-display">
    <div
      class="choose-container"
      v-for="(item,index) in $store.state.catagories"
      :key="index"
      style="margin:1rem"
      @click="routeToCollection('view-collection', item._id, item.title)"
    >
      <v-img
        :src="item.imageUrl"
        :lazy-src="item.imageUrl"
        aspect-ratio="1"
        class="grey lighten-2 collection-image"
      >
        <template v-slot:placeholder>
          <v-layout fill-height align-center justify-center ma-0>
            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
          </v-layout>
        </template>
      </v-img>
 
      <div>
        <h3 style="font-family: 'DINPro Regular'" center>{{ item.title}}</h3>
      </div>
    </div>
       </div>
    <h3 @click="routeToCollection('view-collection', 'all')" id="allText" center>All</h3>
  </div>
</template>

<script>
import { CMS } from "../../api";

export default {
  beforeCreate() {
    this.$store.dispatch("updateCurrentFilter", "Catagories");
    CMS.getCatagories(this, response => {});
  },
  created() {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    routeToCollection(route, collection, name) {
      if (collection === "all")
        this.$store.dispatch("updateCurrentFilter", "All");
      else this.$store.dispatch("updateCurrentFilter", name);
      this.drawer = false;
      this.$store.dispatch("updateCollection", collection);
      this.$router.push({ name: route });
    }
  }
};
</script>

<style scoped>
.nav-tile {
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.inner-display {
  display: flex;
  flex-flow: row wrap;
  padding: 1rem;
  align-items: center;
  justify-content: center;
  margin-top: 2rem;
}
.choose-container {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  width: auto;
  padding: 1rem;
}
.choose-container:hover {
  cursor: pointer;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
}
.inner-container {
  background-color: white;
  min-height: 100vh;
  padding-top: 2rem;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content:center;
}
#allText {
  font-family: "DINPro Regular";
  color: gray;
  font-size: 2rem;
  margin: 2rem;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}
#allText:hover {
  cursor: pointer;
  color: black;
}
#drawerButton {
  position: fixed;
}
.nav-tile:hover {
  cursor: pointer;
  box-shadow: rgba(0, 0, 0, 0.3) 0 16px 16px 0;
  -webkit-box-shadow: rgba(0, 0, 0, 0.3) 0 16px 16px 0;
  -moz-box-shadow: rgba(0, 0, 0, 0.3) 0 16px 16px 0;
}
.collection-image {
  height: 15rem;
  width: 15rem;
}
</style>



// WEBPACK FOOTER //
// ChooseCollection.vue?6b114c35